export default __webpack_public_path__ + "static/media/bolt-icon.5d72b69c.svg";